export default __webpack_public_path__ + "static/media/itunes.08d9161a.svg";